import cookieUtils from '../utils/rbmc.cookie-utils.js';
import urlUtils from '../utils/rbmc.url-utils.js';
import logger from '../utils/rbmc.logger';

const subShop = {

    handleIndicationFromPage: function (subShopIndication) {
        let operation          = subShopIndication.data('subshop-indication-operation');
        let subShopIndications = subShopIndication.data('subshop-indications');
        // if the operation is CLEAR we remove the subShop cookie -> no subShop specific navigation anymore
        if (operation !== undefined && operation === 'CLEAR') {
            this.clearSubShop();
        } else if (subShopIndications !== undefined) {
            // if the operation is NOT clear -> we hav to check if we have subShop indications in the dom
            let availableSubShops = JSON.parse(subShopIndications.replace(new RegExp("'", 'g'), "\""));
            if (availableSubShops.length > 0) {
                // if we have subShop indications and the operation is SET -> we store the first
                // subShop in the cookie and do not care if the cookie was already present or not
                if (operation === 'SET') {
                    let subShopName           = availableSubShops[0].subshop.name,
                        subShopCookie         = this.createSubShopCookieValue(availableSubShops[0]),
                        existingSubShopCookie = cookieUtils.readCookie("subShop");

                    // store the subShop to cookie
                    if (existingSubShopCookie != null || existingSubShopCookie !== subShopCookie) {
                        cookieUtils.createCookie('subShop', subShopCookie);
                        logger.debug( `subshop cookie created: ${subShopCookie}`);
                    }
                } else if (operation === 'CLEAR_IF_DIFFERENT') {
                    // if the operation is CLEAR_IF_DIFFERENT we check, if the subShop from the
                    // cookie is part of the subShop indications. If not, we remove the cookie,
                    // otherwise we keep it.
                    this.clearSubShopIfDifferent(availableSubShops)
                }

                return;
            }
        }
    },

    createSubShopCookieValue: function (subShopData) {
        // value of the cookie: code,name,urlToSubShopPage,idOFSubShopNavigationComponent
        let comma               = ',',
            subShopCode         = subShopData.subshop.code,
            subShopName         = subShopData.subshop.name,
            subShopLink         = urlUtils.getBaseUrl().slice(0, -1) + subShopData.url,
            subShopLogo         = subShopData.logoId,
            subShopNavigationId = subShopData.navigationId;
        return `${subShopCode}${comma}${subShopName}${comma}${subShopLink}${comma}${subShopLogo || undefined}${comma}${subShopNavigationId || undefined}`;
    },

    clearSubShop: function () {
        cookieUtils.removeCookie('subShop');
        logger.debug( `subshop cookie removed`);
    },

    clearSubShopIfDifferent: function (availableSubShops) {
        let existingSubShopCookie = cookieUtils.readCookie('subShop'),
            different             = true;
        if (existingSubShopCookie !== null) {
            let currentSubShop = existingSubShopCookie.split(',')[0];

            availableSubShops.forEach(function (data) {
                if (data.subshop.code === currentSubShop) {
                    // refresh cookie
                    cookieUtils.createCookie('subShop', subShop.createSubShopCookieValue(data));
                    logger.debug( `subshop cookie refreshed`);
                    different = false;
                    return false;
                }
            });
        }
        if (different) {
            this.clearSubShop()
        }
    },

    getCurrentSubShop: function () {
        // read from cookie and track it
        let subShopCookie = cookieUtils.readCookie('subShop');
        if (subShopCookie != null) {
            return subShopCookie.split(',')[1];
        }
        return '';
    },

    handleSubShopIndication() {
        let subShopIndication = $('#subshopIndication');
        if (subShopIndication !== undefined) {
            this.handleIndicationFromPage(subShopIndication);
        }
    }
};

$(() => {
    /**
     * Attention: Archibald needs that to handle everything related to subshop (navigation, logo, search, ...)
     */
    if (RedBull.config.archibaldRenderingEnabled) {
        subShop.handleSubShopIndication();
    }
});

export default subShop;
